const currency = 'EUR'

function trackPageView() {
  if (typeof fbq !== 'function') return
  fbq('track', 'PageView')
}

function trackPurchase(value) {
  if (typeof fbq !== 'function') return
  fbq('track', 'Purchase', { currency, value })
}

export default { trackPageView, trackPurchase }
